export default {
  install(Vue) {
    Vue.prototype.$icon = function (id) {
      const icons = {
        6046: "mdi-soccer",
        54094: "mdi-tennis-ball",
        154919: "mdi-boxing-glove",
        48242: "mdi-basketball",
        154914: "mdi-baseball",
        154830: "mdi-volleyball",
        10: "mdi-trophy-award",
        687890: "mdi-gamepad-variant-outline"
      }

      return icons[id]
    }
  }
}